import { compact } from 'lodash/fp';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TextKey } from '@mews-commander/enums';
import { HorizontalAlignment, VerticalAlignment } from '@optimus-web/core';
import { isUpdateSnackbarVisible } from '../selectors/snackbars';
import AlertHolder from '../components/AlertHolder';
import Alert from '../components/Alert';
import { AlertTransition, Transition } from '../components/AlertTransition';
import { forceReload } from '../../app/actions/common';
import { isAppOnline } from '../../app/reducers/status';
import AlertType from '../enums/AlertType';

interface Props {
    isUpdateVisible?: boolean;
    isOnline?: boolean;
    handleRefresh?: $TSFixMeFunction;
}

const SnackbarHolder = ({ handleRefresh, isUpdateVisible, isOnline }: Props) => {
    const updateAction = {
        labelKey: TextKey.Refresh,
        onClick: handleRefresh,
    };

    const alerts = compact([
        !isOnline && (
            <AlertTransition key="offline" transition={Transition.FadeUp}>
                <Alert {...offlineProps} />
            </AlertTransition>
        ),
        isUpdateVisible && isOnline && (
            <AlertTransition key="update" transition={Transition.FadeUp}>
                <Alert {...updateProps} action={updateAction} />
            </AlertTransition>
        ),
    ]);

    return (
        <AlertHolder
            alerts={alerts}
            horizontalPosition={HorizontalAlignment.Left}
            verticalPosition={VerticalAlignment.Bottom}
        />
    );
};

const offlineProps = {
    id: 'offlineSnackbar',
    type: AlertType.Info,
    messageKey: TextKey.OfflineErrorMesssage,
};

const updateProps = {
    id: 'updateSnackbar',
    type: AlertType.Info,
    messageKey: TextKey.CommanderVersionChangedMessage,
};

export default connect(
    createStructuredSelector({
        isUpdateVisible: isUpdateSnackbarVisible,
        isOnline: isAppOnline,
    }),
    {
        handleRefresh: forceReload,
    }
)(SnackbarHolder);
